import "./index.scss";

import Table from "@Components/Table";
import { USERS_TABLE_COLUMNS } from "@Pages/UsersPage/usersColumns";
import { IOrganizationUser } from "@Store/Organizations/types";
import { setUserModal, setUserModalType } from "@Store/Users/actions";
import { selectOrganizationUsers } from "@Store/Users/selectors";
import { useAppDispatch, useAppSelector } from "@hooks";
import { TableColumn } from "react-data-table-component";

type UserTabProps = {
  dispatch: ReturnType<typeof useAppDispatch>;
};

function UsersTabContent(props: UserTabProps) {
  const { dispatch } = props;

  const userList: IOrganizationUser[] = useAppSelector(selectOrganizationUsers);

  const onEditUser = (row: IOrganizationUser): void => {
    dispatch(setUserModal(row));
    dispatch(setUserModalType("update"));
  };

  const userTableColumn: TableColumn<IOrganizationUser>[] =
    USERS_TABLE_COLUMNS(onEditUser);

  return (
    <div className="users-tab-content">
      <Table columns={userTableColumn} data={userList} />
    </div>
  );
}

export default UsersTabContent;
